import React from 'react';
import useOurJourney from '../../../hooks/useOurJourney';
import CommunityImg from '../../../Common/CommunityImg/CommunityImg';
import {default as badge} from '../../../../images/eco-alliance-badge.svg';
import './EcoOurJourney.scss';

const EcoOurJourney = () => {

  const jList = useOurJourney();
  const {edges : journeyPostList} = jList.OurJourneyPosts;
  
  const openBlog = (slug) => window.open(`https://www.noissue.co/blog/${slug}`, '_blank', 'noopener');

  return (
    <div className="noissue__eco-alliance__sustainability__container__tabs__eco-our-journey">
      <div className="eco-community-content">
        At noissue, we define sustainability as systems that are healthy, productive and resilient in the long-term. We are creating a business that’s built to last to ensure our planet, our people and our company’s long-term wellbeing. This means when we use resources to meet the needs of the present, we won’t compromise the needs of those in the future. Our Eco-Alliance lets you plant a tree with your order, and helps contribute to global reforestation, just one of the many initiatives we have!
      </div>
      <div className={`eco-our-journey-blocks-list ${journeyPostList.length < 4 && 'center-journey-post'}`}>
        {
          journeyPostList.map((item, idx) => {
            return <div  key={idx} >
              <div className="eco-our-journey-blocks-date">{item.node.published_at}</div>
              <div className="eco-our-journey-blocks" key={idx}>
                  <CommunityImg 
                    className="eco-our-journey-blocks-badge" 
                    src={badge} 
                    alt="eco alliance badge" 
                  />
                  <CommunityImg 
                    role="presentation"
                    className="eco-our-journey-blocks-image" 
                    onClick={()=>openBlog(item.node.slug)}  
                    src={item.node.feature_image} 
                    alt="community blog" 
                  />
                  <div className="eco-our-journey-blocks-details">
                    {item.node.excerpt}
                  </div>
                  <div 
                    role="presentation" 
                    onClick={()=>openBlog(item.node.slug)} 
                    className="eco-our-journey-blocks-read-more">
                      Read More
                  </div>
              </div>
            </div>
            
          })
        }
        <div className="eco-our-journey-blocks-empty"></div>
      </div>
    </div>
  )
}

export default EcoOurJourney;